// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"2952eeec","234":"4163b8ac","630":"b9ed65da"}[chunkId] + ".js";
};